import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import actions from 'actions/formGroups'
import Component from 'components/FormTemplates/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  formGroups: selectors.formGroups.selectOptions(state),
})

export default connect(mapStateToProps, { getFormGroups: actions.getOptions })(Component)
